/**
 * @file The width of an attainment bar: an exact attainment ratio as a
 * percent to one place, held between 0 and 100. Consumers: the Overview's
 * person table and `AnalyticsAttainmentBar` (the team table and the Home
 * tiles). Display geometry only; the percent beside a bar comes from
 * `analyticsPercentText` on the same exact ratio.
 */
import { analyticsFractionDecimal } from '#types';
import type { AnalyticsFraction } from '#types';

const FULL = 100;

export const analyticsAttainmentPercent = (
  attainment: AnalyticsFraction,
): number =>
  Math.min(
    FULL,
    Math.max(
      0,
      Number(
        analyticsFractionDecimal(
          {
            numerator: attainment.numerator * BigInt(FULL),
            denominator: attainment.denominator,
          },
          1,
        ),
      ),
    ),
  );
